import { Cell, CellProps } from 'react-aria-components'

import { joinStyles } from 'app/utils/theme'

import * as styles from './index.css'

type TableCellProperties = CellProps & {
    className?: string
}

export const TableCell = ({
    className,
    ...properties
}: Readonly<TableCellProperties>): JSX.Element => {
    return (
        <Cell
            className={joinStyles(styles.root, className)}
            {...properties}
        />
    )
}
